import union from 'lodash/union'

// Creates a reducer managing pagination, given the action types to handle,
// and a function telling how to extract the key from an action.
const paginate = ({ types, mapActionToKey }) => {
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected types to be an array of three elements.')
  }
  if (!types.every(t => typeof t === 'string')) {
    throw new Error('Expected types to be strings.')
  }
  if (typeof mapActionToKey !== 'function') {
    throw new Error('Expected mapActionToKey to be a function.')
  }

  const [ requestType, successType, failureType ] = types

  const updatePagination = (state = {
    code: null,
    timestamp: null,
    isFetching: false,
    prevPage: null,
    nextPage: null,
    pageCount: 0, // counts pages number readed by pagination
    totalPages: 0, // total pages available
    ids: []
  }, action) => {
    switch (action.type) {
      case requestType:
        return {
          ...state,
          timestamp: + Date.now(),
          isFetching: true
        }
      case successType:
        return {
          ...state,
          code: action.response.code,
          timestamp: + Date.now(),
          isFetching: false,
          ids: action.reset !== true ? union(state.ids, action.response.ids) : action.response.ids,
          prevPage: action.response.prevPage,
          nextPage: action.response.nextPage,
          totalPages: action.response.totalPages,
          pageCount: state.pageCount + 1
        }
      case failureType:
        return {
          ...state,
          code: action.response.code,
          timestamp: + Date.now(),
          isFetching: false
        }
      default:
        return state
    }
  }

  return (state = {}, action) => {
    // Update pagination by key
    switch (action.type) {
      case requestType:
      case successType:
      case failureType:
        const key = mapActionToKey(action)
        if (typeof key !== 'string') {
          throw new Error('Expected key to be a string.')
        }
        return {
          ...state,
          [key]: updatePagination(state[key], action)
        }
      default:
        return state
    }
  }
}

export default paginate


// WEBPACK FOOTER //
// ./src/reducers/paginate.js